import React, { useId } from 'react';
import { buildPlatformSlatRects } from './platformSlatGeometry';

const VB = 64;
const CX = VB / 2;

/**
 * Platform mark: outer circle ring + horizontal slats clipped inside (viewBox 0 0 64 64).
 */
export function BesperPlatformSlatMarkGroup({ iconColor = '#022d54' }) {
  const uid = useId().replace(/:/g, '');
  const clipId = `besperPlatClip-${uid}`;
  const rects = buildPlatformSlatRects({
    width: VB,
    height: VB,
    cx: CX,
    maxW: 22,
    barH: 2.1,
    gap: 1.05,
    staggerScale: 0.22,
  });

  return (
    <g fill="none" strokeLinecap="round" strokeLinejoin="round">
      <defs>
        <clipPath id={clipId}>
          <circle cx={CX} cy={CX} r={21} />
        </clipPath>
      </defs>
      <circle cx={CX} cy={CX} r={27} stroke={iconColor} strokeWidth={2.25} />
      <g clipPath={`url(#${clipId})`}>
        {rects.map((r, i) => (
          <rect
            key={`slat-${i}`}
            x={r.x}
            y={r.y}
            width={r.w}
            height={r.h}
            rx={r.rx}
            ry={r.rx}
            fill={iconColor}
            fillOpacity={r.opacity}
          />
        ))}
      </g>
    </g>
  );
}

/**
 * Standalone SVG for marketplace provider corner and similar.
 */
export function BesperPlatformSlatMark({
  size = 28,
  className = '',
  iconColor = '#022d54',
  title,
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${VB} ${VB}`}
      className={className}
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      aria-label={title}
    >
      <BesperPlatformSlatMarkGroup iconColor={iconColor} />
    </svg>
  );
}
